var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("publishSharedLink.title")))]),
      _c(
        "span",
        { staticClass: "close", on: { click: _vm.closePublishSharedLink } },
        [_vm._v(_vm._s(_vm.$t("publishSharedLink.closeWindow")))]
      ),
    ]),
    _c("div", { staticClass: "body" }, [
      _c("div", { staticClass: "shared-link-list" }, [
        _c(
          "div",
          { staticClass: "list" },
          [
            _vm.sharedLinkList.length === 0
              ? _c("div", { staticClass: "description" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("publishSharedLink.noLinks"))),
                  ]),
                ])
              : _vm._e(),
            _vm.sharedLinkList.length
              ? _c(
                  "transition-group",
                  { attrs: { name: "tran" } },
                  _vm._l(_vm.sharedLinkList, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.sharedLinkId,
                        staticClass: "list-item",
                        class: {
                          active:
                            _vm.selected &&
                            _vm.selected.sharedLinkId === item.sharedLinkId,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.select(item)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "name ellipsis" }, [
                          _vm._v(_vm._s(item.name || "NO TITLE")),
                        ]),
                        _c("div", { staticClass: "link-wrapper" }, [
                          _c("div", { staticClass: "link ellipsis" }, [
                            item.enabled
                              ? _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.resolveSharedLinkPath(item),
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.sharedLinkPath(item)) +
                                        " "
                                    ),
                                  ]
                                )
                              : _c("a", { staticClass: "disabled-link" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("publishSharedLink.disabledLink")
                                    )
                                  ),
                                ]),
                          ]),
                          item.enabled
                            ? _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:copy",
                                      value: _vm.sharedLinkPath(item),
                                      expression: "sharedLinkPath(item)",
                                      arg: "copy",
                                    },
                                    {
                                      name: "clipboard",
                                      rawName: "v-clipboard:success",
                                      value: _vm.onCopy,
                                      expression: "onCopy",
                                      arg: "success",
                                    },
                                  ],
                                  staticClass: "copy",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/img/icon/content_copy.svg"),
                                      alt: "content-copy",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "create-shared-link",
            on: { click: _vm.createSharedLink },
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("publishSharedLink.createNew")))]),
            !_vm.plan
              ? _c("span", { staticClass: "note" }, [
                  _vm._v(_vm._s(_vm.$t("publishSharedLink.freePlanNote"))),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _c(
        "div",
        {
          key: _vm.selected ? _vm.selected.sharedLinkId : null,
          staticClass: "container",
        },
        [
          _c("div", { staticClass: "main" }, [
            _vm.selected
              ? _c("div", { staticClass: "shared-link-name" }, [
                  _c("div", { staticClass: "header-container" }, [
                    _c("div", { staticClass: "header-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("publishSharedLink.linkNameHeader"))
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "input-wrapper" },
                    [
                      _c("input-text", {
                        staticClass: "input",
                        attrs: {
                          label: _vm.$t(
                            "publishSharedLink.linkNamePlaceholder"
                          ),
                          type: "text",
                          maxlength: 50,
                        },
                        model: {
                          value: _vm.selected.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.selected, "name", $$v)
                          },
                          expression: "selected.name",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.selected
              ? _c("div", { staticClass: "manuscript-list" }, [
                  _c("div", { staticClass: "header-container" }, [
                    _c("div", { staticClass: "header-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("publishSharedLink.manuscriptSelectionHeader")
                        )
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "dropup-menu",
                        on: {
                          click: function ($event) {
                            return _vm.toggleMenu(_vm.SharedLinkKind.MANUSCRIPT)
                          },
                        },
                      },
                      [
                        _c("img", {
                          class: { open: _vm.isOpenManuscriptList },
                          attrs: {
                            src: require("@/assets/img/icon/expand_less.svg"),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm.isOpenManuscriptList
                    ? _c(
                        "div",
                        { staticClass: "list" },
                        _vm._l(_vm.manuscriptList, function (manuscript) {
                          return _c(
                            "div",
                            {
                              key: manuscript.key,
                              staticClass: "list-item",
                              on: {
                                click: function ($event) {
                                  return _vm.onClickItem(
                                    manuscript,
                                    _vm.SharedLinkKind.MANUSCRIPT
                                  )
                                },
                              },
                            },
                            [
                              _c("checkbox-icon", {
                                attrs: {
                                  isChecked: _vm.isChecked(
                                    manuscript,
                                    _vm.SharedLinkKind.MANUSCRIPT
                                  ),
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "manuscript-title ellipsis" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      manuscript.title ||
                                        _vm.$t("publishSharedLink.untitledItem")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "header-container" }, [
                    _c("div", { staticClass: "header-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("publishSharedLink.plotSelectionHeader"))
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "dropup-menu",
                        on: {
                          click: function ($event) {
                            return _vm.toggleMenu(_vm.SharedLinkKind.PLOT)
                          },
                        },
                      },
                      [
                        _c("img", {
                          class: { open: _vm.isOpenPlotList },
                          attrs: {
                            src: require("@/assets/img/icon/expand_less.svg"),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm.isOpenPlotList
                    ? _c(
                        "div",
                        { staticClass: "list" },
                        _vm._l(_vm.plotList, function (plot) {
                          return _c(
                            "div",
                            {
                              key: plot.plotId,
                              staticClass: "list-item",
                              on: {
                                click: function ($event) {
                                  return _vm.onClickItem(
                                    plot,
                                    _vm.SharedLinkKind.PLOT
                                  )
                                },
                              },
                            },
                            [
                              _c("checkbox-icon", {
                                attrs: {
                                  isChecked: _vm.isChecked(
                                    plot,
                                    _vm.SharedLinkKind.PLOT
                                  ),
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "manuscript-title ellipsis" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      plot.name ||
                                        _vm.$t("publishSharedLink.untitledItem")
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.selected
              ? _c(
                  "div",
                  { staticClass: "warning" },
                  [
                    _c("warning-icon", { staticClass: "warning-icon" }),
                    _c("div", { staticClass: "warning-title" }, [
                      _vm._v(_vm._s(_vm.$t("publishSharedLink.warningTitle"))),
                    ]),
                    _c("div", { staticClass: "warning-text" }, [
                      _vm._v(_vm._s(_vm.$t("publishSharedLink.warningText"))),
                    ]),
                  ],
                  1
                )
              : _c("div", { staticClass: "description" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("publishSharedLink.selectFromList"))),
                  ]),
                ]),
          ]),
          _c("div", { staticClass: "controller" }, [
            _c("div", { staticClass: "confirm-action-buttons" }, [
              _vm.plan !== 0
                ? _c(
                    "button",
                    {
                      staticClass: "delete",
                      attrs: { disabled: !_vm.selected },
                      on: { click: _vm.onClickDelete },
                    },
                    [_c("delete-icon", { staticClass: "delete-icon" })],
                    1
                  )
                : _vm._e(),
              _vm.selected
                ? _c("div", [
                    _vm.selected.enabled
                      ? _c(
                          "button",
                          {
                            staticClass: "button change-status",
                            on: { click: _vm.onClickStop },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("publishSharedLink.stopSharing"))
                            ),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "button change-status",
                            on: { click: _vm.resumeSharedLink },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("publishSharedLink.resumeSharing"))
                            ),
                          ]
                        ),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "wrapper" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.sharedLinkPath(_vm.selected),
                      expression: "sharedLinkPath(selected)",
                      arg: "copy",
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:success",
                      value: _vm.onCopy,
                      expression: "onCopy",
                      arg: "success",
                    },
                  ],
                  staticClass: "button copy",
                  attrs: { disabled: !_vm.selected || !_vm.selected.enabled },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("publishSharedLink.copyLink")) + " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "button save",
                  attrs: { disabled: !_vm.selected },
                  on: { click: _vm.save },
                },
                [_vm._v(_vm._s(_vm.$t("publishSharedLink.save")))]
              ),
            ]),
          ]),
          _vm.isDeleting || _vm.isStopping
            ? _c("div", { staticClass: "mask" }, [
                _c("h1", [
                  _vm._v(
                    _vm._s(
                      _vm.isDeleting
                        ? _vm.$t("publishSharedLink.deleteConfirmTitle")
                        : _vm.$t("publishSharedLink.stopConfirmTitle")
                    )
                  ),
                ]),
                _c("div", [
                  _c("div", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isDeleting
                            ? _vm.$t("publishSharedLink.deleteConfirmBody1")
                            : _vm.$t("publishSharedLink.stopConfirmBody1")
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.isDeleting
                            ? _vm.$t("publishSharedLink.deleteConfirmBody2")
                            : _vm.$t("publishSharedLink.stopConfirmBody2")
                        ) +
                        " "
                    ),
                  ]),
                ]),
                _vm.isDeleting
                  ? _c("div", { staticClass: "mask-controller" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button danger",
                          on: { click: _vm.deleteSharedLink },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("publishSharedLink.deleteButton"))
                          ),
                        ]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button cancel",
                          on: { click: _vm.cancelDelete },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                      ),
                    ])
                  : _c("div", { staticClass: "mask-controller" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button danger",
                          on: { click: _vm.stopSharedLink },
                        },
                        [_vm._v(_vm._s(_vm.$t("publishSharedLink.stopButton")))]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button cancel",
                          on: { click: _vm.cancelStop },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                      ),
                    ]),
              ])
            : _vm._e(),
        ]
      ),
      _c("span", { staticClass: "info-belt", class: { visible: _vm.copied } }, [
        _vm._v(_vm._s(_vm.$t("publishSharedLink.copiedMessage"))),
      ]),
      _c("span", { staticClass: "info-belt", class: { visible: _vm.saved } }, [
        _vm._v(_vm._s(_vm.$t("publishSharedLink.savedMessage"))),
      ]),
      _c(
        "span",
        { staticClass: "info-belt", class: { visible: _vm.deleted } },
        [_vm._v(_vm._s(_vm.$t("publishSharedLink.deletedMessage")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }